import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../../../../../../themes/Colors";

const PromotionCategoryCard = ({
  name,
  amount,
  count,
  discountAmount,
  marginRight,
  onClick,
}) => {
  const [hover, setHover] = useState(false);
  //   const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        minHeight: 250,
        width: 200,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#00000030",
        marginLeft: 20,
        marginTop: 50,
        borderRadius: 4,
        marginRight: marginRight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        WebkitBoxShadow: hover
          ? "0px 0px 7px 2px #00000020"
          : "0px 0px 0px 0px #00000000",
        backgroundColor: hover ? BlackAndWhite.red50 : BlackAndWhite.secondary,
      }}
    >
      <div style={{ flex: 1 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 26, fontWeight: "bold", marginTop: 20 }}>
            {amount ? amount : "R 0.00"}
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: 5,
              opacity: 0.7,
              fontSize: 15,
            }}
          >
            AMOUNT
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 26, fontWeight: "bold", marginTop: 20 }}>
            {count ? count : "0"}
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: 5,
              opacity: 0.7,
              fontSize: 15,
            }}
          >
            COUNT
          </div>
        </div>
      </div>
      <div style={{ marginTop: 10 }}>{discountAmount}</div>
      <div
        style={{
          fontSize: 12,
          marginTop: 3,
          marginBottom: 3,
          fontWeight: "bold",
        }}
      >
        DISCOUNT AMOUNT
      </div>
      <div
        style={{
          marginBottom: 20,
          width: "80%",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        {name}
      </div>
    </div>
  );
};

export default PromotionCategoryCard;
